// components/Surveys/EmojiInput.js
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 32px;          /* espaçamento aumentado */
  padding: 24px 0;    /* padding superior/inferior */
`

const EmojiButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: ${props => (props.selected ? 1 : 0.5)};
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
  }
`

const EmojiImg = styled.img`
  width: 36px;        /* tamanho reduzido para 36px */
  height: 36px;
  object-fit: contain;
`

const Label = styled.span`
  margin-top: 6px;    /* leve redução no margin-top */
  font: 14px/1.3 'Inter', sans-serif;
  color: #4b5563;
  text-align: center;
`

/**
 * @param {{ id: string|number; label: string; value: string|number }[]} options
 * @param {number} value      — índice atualmente selecionado (1..options.length)
 * @param {(idx:number)=>void} onChange
 */
export default function EmojiInput({ options = [], value = 0, onChange }) {
  return (
    <Container>
      {options.map((opt, index) => {
        const idx = index + 1
        return (
          <EmojiButton
            key={opt.idx}
            type="button"
            selected={value === idx}
            onClick={() => onChange(idx)}
          >
            <EmojiImg
              src={`/images/icons/smile_${idx}.svg`}
              alt={`smile_${idx}.svg`}
            />
            <Label>{opt.label || ''}</Label>
          </EmojiButton>
        )
      })}
    </Container>
  )
}
